import { trackPromise } from 'react-promise-tracker';
import HttpError, { ResponseProps } from '../ExtendedError';
import { getLogger } from '../logger/logger';
import { ErrorResponseBody } from '../../models/ErrorResponseBody';

const handleError = (error: Error) => {
  const log = getLogger('httpFetch');
  log.error(error);
  throw error;
};

const throwError = (response: ResponseProps, message?: string, body?: ErrorResponseBody) => {
  throw new HttpError(response, message, body);
};
const handleFailedResponse = (response: Response) => {
  if (response.status >= 400) {
    const responseData = {
      status: response.status,
      statusText: response.statusText,
      url: response.url,
    };
    //TODO: See if message is needed and handle the case when it is null, if needed
    return response.json().then(
      (body) => (body ? throwError(responseData, body.message, body) : throwError(responseData)),
      () => throwError(responseData),
    );
  }
  return Promise.resolve(response);
};

const httpFetch: (url: RequestInfo, params?: RequestInit) => Promise<Response> = (url: RequestInfo, params: RequestInit = {}) =>
  trackPromise(fetch(url, { ...params, cache: 'no-cache', credentials: 'include' }))
    .then(handleFailedResponse)
    .catch(handleError);

export default httpFetch;
